<script>
  import './style.scss';
  import template from './template.html';
  import {cloneDeep} from 'lodash';

  export default {

    props: {
      tableData: Object
    },

    template,

    methods: {

      emptyRows () {
        this.grid.rows().remove().draw();
      },

      addRows (rows, headers) {
        setTimeout(() => {
          console.log('adding rows');

          let newRows = JSON.parse(JSON.stringify(rows));

          let newHeaders  = headers.map(h => h.name);

          let gridRows = newRows.map(row => {
            let theRow = cloneDeep(row);

            //@TODO - REMOVE COMMENT
            return newHeaders.map(h => theRow[h] || theRow['comment'] || "");
          })

          this.grid.rows.add(gridRows).draw();

          this.grid.columns.adjust();
        })
      }
    },

    watch: {

      tableData (val) {

        if (this.tableLoaded && this.grid.rows().length) {
          this.emptyRows();
        }

        this.addRows(val.rows, val.headers);
      }
    },

    computed: {},

    data () {
      const id = Math.floor(Math.random() * 1000);

      return {
        id,

        grid: {},

        tableLoaded: false
      }
    },

    updated () {
      let gridElement = $(`#ag-${this.id}`);

      if (!this.tableLoaded && gridElement.length) {

        this.grid = gridElement.DataTable({
          scrollX: true,
          responsive: true,
          dom: 'Bfrtip',
          order: [[0, "desc"]]
        });

        this.tableLoaded = true;
      }
    }
  };
</script>
